const state = {
  currStep: 0,
  brandName: '',
  slogan: '',
  brandKeywords: [],
  newKeyword: '',
  brandColors: [],
}

const getters = {
  currStep: state => state.currStep,
  isCurrStepValid: (state, getters) => {
    switch (state.currStep) {

      case 0:
        if(state.brandName !== '') {
          return true;
        }
        return false;
        break;

      case 1:
        if(state.brandKeywords.length >= 1 || state.newKeyword !== '') {
          return true;
        }
        return false;
        break;

      case 2:
        if(state.brandColors.length >= 1) {
          return true;
        }
        return false;
        break;
    }
  },
  brandName: state => state.brandName,
	slogan: state => state.slogan,
}

const mutations = {
	SET_CURR_STEP(state, payload) {
		state.currStep = payload;
	},
	SET_BRAND_NAME(state, payload) {
		state.brandName = payload;
	},
	SET_SLOGAN(state, payload) {
		state.slogan = payload;
	},
	SET_BRAND_KEYWORDS(state, payload) {
		state.brandKeywords = payload;
  },
  ADD_BRAND_KEYWORD(state, payload) {
    const newKeywords = [...state.brandKeywords, payload];
    state.brandKeywords = newKeywords;
  },
  SET_NEW_KEYWORD(state, payload) {
    state.newKeyword = payload;
  },
  SET_BRAND_COLORS(state, payload) {
    state.brandColors = payload;
  }
}

const actions = {
	nextStep({ commit, getters, state }) {
    if(getters.isCurrStepValid) {
      commit('SET_CURR_STEP', getters.currStep + 1);
    }
	},
	prevStep({ commit, getters }) {
		commit('SET_CURR_STEP', getters.currStep - 1);
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
